import type React from "react"
import { Box, Skeleton } from "@mui/material"

export const NotificationSidebarSkeleton: React.FC = () => {
    return (
        <Box sx={{ p: 2, height: "100%" }}>

            <Box sx={{ mb: 3 }}>
                <Skeleton variant="text" width={120} height={32} sx={{ mb: 1 }} />
                {[1, 2, 3].map((item) => (
                    <Box key={item} sx={{ display: "flex", alignItems: "center", mb: 1, pl: 2 }}>
                        <Skeleton variant="circular" width={20} height={20} sx={{ mr: 1 }} />
                        <Skeleton variant="text" width={100} height={24} />
                    </Box>
                ))}
            </Box>

            <Box>
                <Skeleton variant="text" width={120} height={32} sx={{ mb: 1 }} />
                {[1, 2, 3, 4, 5].map((item) => (
                    <Box key={item} sx={{ mb: 2, pl: 2 }}>
                        <Box sx={{ display: "flex", alignItems: "center", mb: 0.5 }}>
                            <Skeleton variant="circular" width={20} height={20} sx={{ mr: 1 }} />
                            <Skeleton variant="text" width={120} height={24} />
                        </Box>
                        {/* <Skeleton variant="text" width="90%" height={16} sx={{ ml: 3 }} /> */}
                    </Box>
                ))}
            </Box>
        </Box>
    )
}
